import { css } from '@emotion/css';
import { colors } from '@ajaibid/components';

export const styPriceChangeTicker = (icon) => css`
  ::before {
    content: '';
    display: inline-block;
    vertical-align: middle;
    width: 0px;
    height: 0px;
    margin-right: 2px;

    ${icon === 'triangle-up' &&
    `
      margin-top: -2.5px; // Offset by half of triangle height
      border-top: none;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 6px solid ${colors.GREEN_5};
      border-radius: 1px;
    `}

    ${icon === 'triangle-down' &&
    `
      margin-top: -2.5px; // Offset by half of triangle height
      border-top: 6px solid ${colors.RED_5};
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: none;
      border-radius: 1px;
    `}

    ${icon === 'dash' &&
    `
      margin-top: -1px; // Offset by half of dash height
      border-top: 1px solid ${colors.NEUTRAL_5};
      border-left: 5px solid ${colors.NEUTRAL_5};
      border-right: 5px solid ${colors.NEUTRAL_5};
      border-bottom: 1px solid ${colors.NEUTRAL_5};
      border-radius: 1px;
    `}
  }
`;
